/**
 * @ipc/admin-ui · widgets/app-shell · brand-logo — монохромный логотип Inexbrand.
 * SVG отдаётся из public/brand; под тёмную тему перекрашивается фильтром (--logo-filter).
 */
export function BrandLogo({ className }: { className?: string }) {
  return (
    <img
      src="/brand/inexbrand-logo.svg"
      alt="Inexbrand"
      className={className}
      style={{ filter: 'var(--logo-filter)' }}
    />
  );
}
